import { render } from "./StatisticalDiagram.vue?vue&type=template&id=53d1cde4"
import script from "./StatisticalDiagram.vue?vue&type=script&lang=ts"
export * from "./StatisticalDiagram.vue?vue&type=script&lang=ts"
script.render = render

export default script